<app-header-latest></app-header-latest>
<!-- HERO -->
<div class="partners-hero">
  <div class="container-wrapper">
    <div>
      <div class="section-eyebrow">🤝 PARTNER ECOSYSTEM</div>
      <h1>Grow Together<br>with <span style="color:#67e8f9;">NeoHRMZ</span></h1>
      <p>Join a network of 350+ technology partners, system integrators, and resellers building on and around the NeoHRMZ platform — and earn together.</p>
      <div style="display:flex;gap:16px;flex-wrap:wrap;">
        <a href="#" class="btn btn-white">Apply to Partner Program</a>
        <a href="#" class="btn btn-outline" style="color:#fff;border-color:rgba(255,255,255,0.3);">Explore Partner Portal</a>
      </div>
    </div>
    <div>
      <div class="partner-stats-widget">
        <div class="pstat"><div class="pstat-num">350+</div><div class="pstat-lbl">Technology Partners</div></div>
        <div class="pstat"><div class="pstat-num">80+</div><div class="pstat-lbl">Countries Covered</div></div>
        <div class="pstat"><div class="pstat-num">$12M</div><div class="pstat-lbl">Partner Revenue Paid</div></div>
        <div class="pstat"><div class="pstat-num">4.9★</div><div class="pstat-lbl">Partner Satisfaction</div></div>
      </div>
    </div>
  </div>
</div>

<!-- PARTNER TIERS -->
<section class="tiers-section">
  <div class="container-wrapper">
    <div class="sec-head">
      <span class="section-eyebrow">🏅 Partnership Tiers</span>
      <h2 class="sec-h2">Find the Right<br><span class="gradient-text">Partnership Level</span></h2>
      <p class="sec-sub">From referral partners to deeply integrated technology alliances — there's a tier for every kind of collaboration.</p>
    </div>
    <div class="tiers-grid">
      <div class="tier-card">
        <div class="tier-card__icon">🤝</div>
        <div class="tier-card__level">Referral Partner</div>
        <div class="tier-card__title">Affiliate</div>
        <div class="tier-card__desc">Introduce NeoHRMZ to your network and earn a generous recurring commission on every deal you close.</div>
        <div class="tier-card__benefits">
          <div class="tier-card__benefit">20% recurring commission</div>
          <div class="tier-card__benefit">Dedicated referral dashboard</div>
          <div class="tier-card__benefit">Co-marketing materials</div>
          <div class="tier-card__benefit">Partner certification badge</div>
        </div>
        <a href="#" class="btn btn-outline" style="width:100%;justify-content:center;">Apply Now</a>
      </div>
      <div class="tier-card tier-card--gold">
        <div class="tier-card__icon">⭐</div>
        <div class="tier-card__level">Solution Partner</div>
        <div class="tier-card__title">Gold</div>
        <div class="tier-card__desc">Build NeoHRMZ implementations, customizations, and integrations for your clients — with full technical and sales support.</div>
        <div class="tier-card__benefits">
          <div class="tier-card__benefit">25% recurring commission</div>
          <div class="tier-card__benefit">Technical onboarding support</div>
          <div class="tier-card__benefit">Joint go-to-market programs</div>
          <div class="tier-card__benefit">Priority support queue</div>
        </div>
        <a href="#" class="btn btn-primary" style="width:100%;justify-content:center;background:#d97706;">Apply Now</a>
      </div>
      <div class="tier-card">
        <div class="tier-card__icon">🏆</div>
        <div class="tier-card__level">Technology Partner</div>
        <div class="tier-card__title">Alliance</div>
        <div class="tier-card__desc">Deep product integration, co-development, and marketplace listing for ISVs building complementary software on the NeoHRMZ platform.</div>
        <div class="tier-card__benefits">
          <div class="tier-card__benefit">Custom revenue share terms</div>
          <div class="tier-card__benefit">API sandbox &amp; sandbox access</div>
          <div class="tier-card__benefit">Marketplace listing</div>
          <div class="tier-card__benefit">Dedicated partner manager</div>
        </div>
        <a href="#" class="btn btn-outline" style="width:100%;justify-content:center;">Contact Us</a>
      </div>
    </div>
  </div>
</section>

<!-- LOGOS -->
<section class="partner-logos-section">
  <div class="container-wrapper">
    <div class="sec-head">
      <span class="section-eyebrow">🌐 Current Partners</span>
      <h2 class="sec-h2">Trusted by<br><span class="gradient-text">Great Companies</span></h2>
    </div>
    <div class="logos-grid">
      <div class="logo-badge"><div class="logo-badge__icon">🏦</div><div class="logo-badge__name">Stripe</div></div>
      <div class="logo-badge"><div class="logo-badge__icon">☁️</div><div class="logo-badge__name">AWS</div></div>
      <div class="logo-badge"><div class="logo-badge__icon">📊</div><div class="logo-badge__name">QuickBooks</div></div>
      <div class="logo-badge"><div class="logo-badge__icon">🔗</div><div class="logo-badge__name">Zapier</div></div>
      <div class="logo-badge"><div class="logo-badge__icon">💬</div><div class="logo-badge__name">Slack</div></div>
      <div class="logo-badge"><div class="logo-badge__icon">📧</div><div class="logo-badge__name">Google Workspace</div></div>
      <div class="logo-badge"><div class="logo-badge__icon">🖥️</div><div class="logo-badge__name">Microsoft 365</div></div>
      <div class="logo-badge"><div class="logo-badge__icon">🐙</div><div class="logo-badge__name">GitHub</div></div>
      <div class="logo-badge"><div class="logo-badge__icon">🎯</div><div class="logo-badge__name">Greenhouse</div></div>
      <div class="logo-badge"><div class="logo-badge__icon">📱</div><div class="logo-badge__name">Workato</div></div>
    </div>
  </div>
</section>

<!-- BENEFITS -->
<section class="partner-benefits">
  <div class="container-wrapper">
    <div class="sec-head">
      <span class="section-eyebrow">💎 Why Partner with Us</span>
      <h2 class="sec-h2">Real Resources,<br><span class="gradient-text">Real Returns</span></h2>
    </div>
    <div class="partner-ben-grid">
      <div class="partner-ben-card">
        <div class="partner-ben-card__icon">💰</div>
        <div class="partner-ben-card__title">Competitive Commissions</div>
        <div class="partner-ben-card__desc">Earn up to 25% recurring revenue share on every deal, with monthly payouts and a transparent real-time tracking dashboard.</div>
      </div>
      <div class="partner-ben-card">
        <div class="partner-ben-card__icon">🎓</div>
        <div class="partner-ben-card__title">Partner Certification &amp; Training</div>
        <div class="partner-ben-card__desc">Free access to the full NeoHRMZ Academy curriculum plus partner-exclusive certification tracks, technical training, and sales playbooks.</div>
      </div>
      <div class="partner-ben-card">
        <div class="partner-ben-card__icon">📣</div>
        <div class="partner-ben-card__title">Co-Marketing Programs</div>
        <div class="partner-ben-card__desc">Joint webinars, co-branded content, shared event sponsorships, and listing in the NeoHRMZ partner marketplace — all included.</div>
      </div>
    </div>
  </div>
</section>

<!-- CTA -->
<section class="partners-cta">
  <div class="container-wrapper">
    <h2 class="partners-cta__h2">Ready to Grow<br>Together?</h2>
    <p class="partners-cta__p">Join 350+ companies already earning with the NeoHRMZ partner program. Applications reviewed within 3 business days.</p>
    <div class="partners-cta__actions">
      <a href="#" class="btn btn-white">Apply to Partner Program</a>
      <a href="#" class="btn btn-outline" style="color:#fff;border-color:rgba(255,255,255,0.3);">Read Partner FAQ</a>
    </div>
  </div>
</section>
<app-peopleflow-footer></app-peopleflow-footer>